// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"647":"01f8a9a4","679":"1ee275c2"}[chunkId] + ".js";
};